var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{ active: _vm.isLoading }},[_c('div',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }